import { useState } from "react";
import clx from "classnames";
import { Input } from "reactstrap";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";

export const CustomInput = ({
  type = "text",
  onChangeHandler,
  customCss,
  placeholder = "",
  label,
  id,
  error = null,
}) => {
  const [showPass, toggle] = useState(false);
  return (
    <div className="input-wrapper">
      {label && <label htmlFor={id}>{label}</label>}
      <Input
        id={id}
        placeholder={placeholder}
        type={type === "password" && showPass ? "text" : type}
        onChange={onChangeHandler}
        className={clx("text-input", customCss && customCss, error && "error")}
        required
      />
      {type === "password" && (
        <div
          onClick={() => {
            toggle((prevState) => !prevState);
          }}
          className="eye-icon"
        >
          {showPass ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
        </div>
      )}
      {error && <span>{error}</span>}
    </div>
  );
};
